// extracted by mini-css-extract-plugin
module.exports = {"socials":"socials-0bab38e7","social-button":"social-button-de15edc0","socialButton":"social-button-de15edc0","overflowWrap":"overflowWrap-0f7a36cd"};